import { render, staticRenderFns } from "./PlanoFaturas.vue?vue&type=template&id=122202bf&scoped=true"
import script from "./PlanoFaturas.vue?vue&type=script&lang=js"
export * from "./PlanoFaturas.vue?vue&type=script&lang=js"
import style0 from "./PlanoFaturas.vue?vue&type=style&index=0&id=122202bf&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122202bf",
  null
  
)

export default component.exports